

import {
  Mixins,
  Component,
  Watch,
  Prop,
} from 'vue-property-decorator';
import {
  Steps, Step, Pagination, Dialog, RadioGroup, Radio, CheckboxGroup, Checkbox,
  Row, Button, Select, Option,
} from 'element-ui';
import { tSearch } from '@/components/Search/index';
// import   from '@/components/searchForm.vue';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/exam';
import question from '@/api/question';
import courseApi from '@/api/course';
import tModal from '@/components/Modal/index.vue';
import tButton from '@/components/Button/tButton.vue';
import { ITButton, IBadge } from '@/components/Button/index.d';
import { IFileCheck, IQuesSearch } from '@/types/question.d';
import { IModalConf } from '@/components/Modal/index.d';
import First from './components/firstStep.vue';
import Second from './components/secondStep.vue';
import tableMixin from './tableMixin';
import addOrModifyTestQs from './components/addOrModifyTestQs.vue';
import questionModal from './components/questionModal.vue';
import SearchForm from './components/worSearch.vue';

@Component({
  components: {
    Steps,
    Step,
    Pagination,
    Dialog,
    RadioGroup,
    Radio,
    CheckboxGroup,
    Checkbox,
    Row,
    tSearch,
    addOrModifyTestQs,
    SearchForm,
    Button,
    tModal,
    tButton,
    First,
    Second,
    Select,
    Option,
    questionModal,
  },
})
export default class worManage extends Mixins(tableMixin) {
  @Prop({
    type: String,
    default: String,
  }) sid!: string;

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/wor/manage:add',
    icon: 'plus',
    callback: this.handleAddCourse,
    log: {
      name: '试题 - 新增',
      component: '/wor/manage:add',
    },
  }];

  private assignBtns: Array<IBTNCONF> = [{
    title: '分配',
    name: '/wor/manage:assign',
    icon: 'share-square-o',
    callback: this.handleAssignQuestion,
    log: {
      name: '试题 - 分配',
      component: '/wor/manage:assign',
    },
  }];

  private nextBtn: ITButton = {
    title: '下一步',
    type: 'primary',
    callback: () => this.handleNextClick(),
  };

  public $refs!: {
    searchForm: SearchForm,
    stepComp: First | Second,
  };

  private isNeedAddOrModify = false;

  // 搜索字符
  private searchValue = '';

  private visible: boolean = false;

  private title: string = '添加正式课';

  private form: any = [];

  private searchFormValue: string = '';

  // 点击修改跳转的添加页面
  private isEdit: Boolean = false;

  private worType: String = '';

  private worContent: string = '';

  private quesKnoledge: string = ''

  private diffculty: string = ''

  private testBank: string = ''

  private testId: string = ''

  private isAddPriew: boolean = false

  private questions = '';

  private anwser = [];

  private quesType = ''

  private postForm = [];

  private isPriew = false;

  private contentPD = '';

  public questionArray: any = [];

  private curModalComp: string = 'First';

  private cid: string = ''; // 课程章节id

  private tModalLoading: { [key: string]: boolean } = { modal: false, next: false };

  private steps: Array<{ title: string, icon: string }> = [
    {
      title: '选择类型',
      icon: 'el-icon-notebook-1',
    },
    {
      title: '拖动排序',
      icon: 'el-icon-sort',
    },
  ];

  private assignQuestion: IModalConf = {
    title: '分配练习题',
    show: false,
    close: () => this.handleModalConf(),
  };

  // eslint-disable-next-line class-methods-use-this
  mounted() {
    // 分页查询所有试题
    this.getPageTestQues();
  }

  get stepActive() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'First': return 1;
      case 'Second': return 2;
    }
    return 1;
  }

  /**
   * @author liuyongchun
   * @desc 打开添加正式课模态框
   */
  handleAddCourse(row: any) {
    this.title = '添加试题';
    this.visible = true;
    this.isNeedAddOrModify = true;
    this.isEdit = false;
    this.isAddPriew = true;
  }

  // 分配按钮点击事件
  handleAssignQuestion() {
    if (this.questionArray.length === 0) {
      this.msg('请选择试题！', 'warning');
      return;
    }
    this.assignQuestion.show = true;
    this.assignQuestion.title = '练习题分配';
  }

  // 分配练习题模态框关闭事件
  handleModalConf() {
    this.assignQuestion.show = false;
    this.curModalComp = 'First';
    this.nextBtn.title = '下一步';
  }

  // 分配练习题模态框下一步点击事件
  handleNextClick() {
    this.tModalLoading.next = true;
    // this.tModalLoading.modal = true;
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'First': this.handleFirstSubmit(); break;
      case 'Second': this.handleSecondSubmit(); break;
    }
  }

  // 点击下一步回调事件
  handleFirstSubmit() {
    (this.$refs.stepComp as First).handleNext().then((res: any) => {
      if (res && res.tid && res.cid) {
        this.tModalLoading.modal = true;
        this.cid = res.cid
        courseApi.getQlist(this.cid).then((question: any) => {
          const idArr: Array<string> = this.questionArray.map((el: any) => el.id || '')
          if (question && question.length > 0) {
            question.forEach((item: any) => {
              if (!idArr.includes(item.question.id)) {
                this.questionArray.push({
                  id: item.question.id,
                  sort: item.sort,
                  knowledge: item.question.knowledge,
                  type: item.question.type,
                  subject: item.question.subject,
                  serial: item.question.serial,
                });
              }
            });
          }
          this.tModalLoading.modal = false;
          this.tModalLoading.next = false;
          this.curModalComp = 'Second';
          this.nextBtn.title = '提 交';
        }).catch(() => {
          this.tModalLoading.modal = false;
          this.tModalLoading.next = false;
        });
      } else {
        this.tModalLoading.next = false;
      }
    });
  }

  // 试题排序事件
  handleSecondSubmit() {
    question.setChapterQuestions({ cid: this.cid, ids: (this.$refs.stepComp as Second).getSort() })
      .then((res: any) => {
        this.tModalLoading.next = false;
        this.tModalLoading.modal = false;
        this.handleModalConf();
        this.getPageTestQues();
      }).catch(() => {
        this.tModalLoading.next = false;
        this.tModalLoading.modal = false;
      });
  }

  // 勾选试题列表事件
  selectionChange(row: any) {
    this.questionArray = row;
  }

  handleEdit(row: any) {
    this.isNeedAddOrModify = true;
    this.isEdit = true;
    this.worType = row.type.name;
    this.worContent = row.title;
    this.testId = row.id;
    this.title = '修改试题';
    this.isAddPriew = true;
  }

  private questionViewProp: any = {
    contentPD: '', // 正确答案
    questions: '', // 标题
    quesType: '', // 题目类型
    answer: '',
    postForm: [],
  }

  // eslint-disable-next-line class-methods-use-this
  priewTestQues(row: any) {
    const { id } = row;
    api.getQuesDetail(id).then((res: any) => {
      this.isPriew = true;
      this.questions = res.title;
      this.anwser = res.correct.split(',');
      this.quesType = res.qstType;
      this.postForm = res.options;
      // 预览子组件属性
      this.questionViewProp.questions = res.title;
      this.questionViewProp.answer = res.correct.split(',');
      this.questionViewProp.quesType = res.qstType;
      this.questionViewProp.postForm = res.options;

      if (res.qstType === '0') {
        const Aar = res.correct.split(',');
        for (let i = 0; i < Aar.length; i++) {
          // eslint-disable-next-line no-param-reassign
          for (let j = 0; j < res.options.length; j++) {
            if (res.options[j].prefix === Aar[i]) {
              // eslint-disable-next-line no-param-reassign
              this.contentPD = res.options[j].content;
              this.questionViewProp.contentPD = res.options[j].content;
            }
          }
        }
      }
    });
  }

  showOrCloseAdd() {
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  closeAddAndRefresh() {
    this.showOrCloseAdd();
    this.getPageTestQues();
  }

  /**
   * @author liuyongchun
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchValue);
      this.searchValue = '';
    } else this.searchValue = this.$refs.searchForm.getFormData().serial;
  }

  /**
   * @desc 普通搜索change事件
   */
  handleSearchChange(v: string) {
    this.getPageTestQues({ serial: v });
  }

  /**
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      subjectId: form.subjectId,
      knowledge: form.knowledge,
      type: form.type,
      serial: form.serial,
    };
    const flag: boolean = Object.values(params).some((em: any) => em && em.length > 0);
    if (flag) this.getPageTestQues(params);
  }

  /**
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getPageTestQues();
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getPageTestQues();
  }
}
